import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { QueryPartInfoSearchByPartNumberDTO } from 'src/app/models/internal/query-partInfo-searchby-partnumber-dto';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { Constants } from 'src/app/core/constants';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { DataService } from 'src/app/services/data.service';
import { of } from 'rxjs';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { SourceType } from 'src/app/models/sourcetype';
import { PackageType } from 'src/app/models/packagetype';
import { DatePipe } from '@angular/common';
import * as moment from 'moment/moment';
import Helper from 'src/app/core/utility/helper';
import { PartInfo } from 'src/app/models/partinfo';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import UIHelper from 'src/app/core/utility/ui-helper';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { SearchFilterCondition } from 'src/app/models/internal/searchfiltercondition';

class FileUploadSnippet {
    pending: boolean = false;
    status: string = 'init';
  
    constructor(public src: string, public file: File) {}
  }

@Component({
    selector: 'app-critical-part',
    templateUrl: './critical-part.component.html',
    styleUrls: ['./critical-part.component.scss']
})

export class CriticalPartsComponent extends BaseGridPage
    implements OnInit, AfterViewInit, ICanExportData {
    fileStream = '';
    errorList: String[] = null;
    selectedFile: FileUploadSnippet;
    bulkUploadResponse: any;
    bulkUploadExcelForm = this.fb.group({
        file: [null, Validators.required],
    });
    @ViewChild('fileInput') fileInput!: ElementRef;
    excelFilenamePrefix = "CriticalParts_";
    searchPartForm: FormGroup;
    locStorage = Constants.localStorageKeys;
    partList: PartBasicInfo[];
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    pipe = new DatePipe('en-US');
    searchClicked = false;
    partFound = false;
    public formErrors = {
        PartNumber: '',
        WarehouseId: '',
        PartCategoryId: '',
        PackageTypeId: '',
    };
    filterForm: FormGroup;
    sourceTypeList: SourceType[];
    criticalClassList: PartSystemDTO[];
    packageTypeList:  PackageType[];
    autoCompletePEURL: string;

    constructor(
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private dataService: DataService,
        private fb: FormBuilder,
        logger: NGXLogger,
        appSettings: AppSettings,
    ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            BasePartNumber: [null],
            CreatedBy: [null],
            WarehouseId: [null],
            CriticalClass: [null]
        });
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
    }

    ngOnInit() {
        this.getSourceTypes();
        this.getCriticalClassList();        
        this.initFilterValues();
        this.fillGrid();
    }

    getPartNumberToSearch() {
        let partNumber: string = this.searchPartForm.controls[
            'partNumberToSearch'
        ].value;
        if (partNumber) {
            partNumber = partNumber.trim();
        }
        return partNumber;
    }

    fillGrid(): void {
        this.partList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.getParts();
    }

    onFileChanged(imageInput: any) {
        this.errorList = null;
        const file: File = imageInput.files[0];
        const reader = new FileReader();
        reader.addEventListener('load', (event: any) => {
          this.selectedFile = new FileUploadSnippet(event.target.result, file);
              this.fileStream = event.target.result;
              this.selectedFile.pending = true;
              const formFileToBeUploaded: FormFileToBeUploaded = {
                  File: this.selectedFile.file,
              };
            this.dataService
              .uploadCriticalPartsExcel(
                formFileToBeUploaded.File
              )
              .subscribe((response: any) => {
                this.fileInput.nativeElement.value = '';
                if (response != null) {
                      this.logger.debug('Excel upload response for bulk upload estimate requests= ' + response);
                      this.bulkUploadResponse = response;
                      if (!response.Success) {
                        this.logger.debug('Excel upload for bulk upload estimate requests failed');
                        this.errorList = response.Messages;
                        this.toastService.error(this.errorList.join("|"));
                      } 
                      else {
                        this.toastService.info(Constants.SUCCESS_FILE_UPLOAD);
                      }
                  }
              });
            });
        reader.readAsDataURL(file);
      
      }
    

    exportData()
    {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';
        const queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO = new QueryPartInfoSearchByPartNumberDTO();
        queryPartInfoSearchByPartNumberDTO.SearchFilter = this.filter;
        queryPartInfoSearchByPartNumberDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode),

        this.dataService      
        .getCriticalPartsExcel(queryPartInfoSearchByPartNumberDTO)
        .subscribe((response: any) => {
            if (response != null && response.Success) {
                UIHelper.DownloadExcelFile(response.Data, filename);
            } else {
                this.toastService.error(
                    'Could not export data'
                );
            }
        });
    }

    getCreatedDate(createdDate: any)
    {
        if(createdDate)
        {
            const formattedDate = this.pipe.transform(createdDate, 'short');
            return formattedDate;
        }
        else
        {
            return '';
        }
    }

    UpdateFilter()
    {
        this.filter.SearchFilterConditions = [];

        if (this.PEAutoComplete.list.length === 0) {
            this.filterForm.controls['CreatedBy'].patchValue(-1);
        } else {
            const condition: SearchFilterCondition = new SearchFilterCondition('CreatedBy', this.PEAutoComplete.selected.Data.UserId, Constants.FILTER_DATATYPE_NUMBER, Constants.FILTER_OPERATOR_TYPE_EQUAL);
            this.filter.SearchFilterConditions.push(condition);
        }

        this.filter = this.setFilterCondition(this.filter, this.filterForm, "BasePartNumber", Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);        
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'WarehouseId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);        
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'CriticalClass', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    clearFilter()
    {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.search();
    }

    getParts() {
      this.UpdateFilter();
      const queryPartInfoSearchByPartNumberDTO: QueryPartInfoSearchByPartNumberDTO = new QueryPartInfoSearchByPartNumberDTO();
      queryPartInfoSearchByPartNumberDTO.SearchFilter = this.filter;
      queryPartInfoSearchByPartNumberDTO.SupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode),

      this.dataService
          .getCriticalParts(queryPartInfoSearchByPartNumberDTO)
          .subscribe((response: any) => {
              if (response != null ) {
                  this.partList = response.Data;
                  this.gridView = of({
                      data: response.Data,
                      total: response.Total ? response.Total : 0,
                  });
              } else {
                  this.toastService.error('Part not found', true);
              }
          });
    }

    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data) {
                this.sourceTypeList = response.Data;
            }
        });
    }

    getCriticalClassList() {
        this.dataService.getCriticalClassList().subscribe((response: any) => {
            if (response && response.Success) {
                this.criticalClassList = response.Data.map(x => { return { Description: x }});
            }
        });
    }

    initiateState() {
        this.partList = [];
    }

    setSourceTypeDesc(dataItem: PartInfo) {
        return  Helper.getSourceTypeToDisplay(dataItem);
    }

    getPackageType(packageTypeId) {
        return Helper.getPackageTypeDescription(packageTypeId);
    }

    onEmptyPE(eventObj: any): void {
        this.filterForm.controls['CreatedBy'].patchValue(null);
        this.PEAutoComplete.list = [];
        if (
            this.filter != null &&
            this.filter.SearchFilterConditions != null &&
            this.filter.SearchFilterConditions.findIndex(
                (x) => x.Field === 'CreatedBy'
            ) >= 0
        ) {
            this.filter.SearchFilterConditions.splice(
                this.filter.SearchFilterConditions.findIndex(
                    (x) => x.Field === 'CreatedBy'
                ),
                1
            );
        }
    }
}
